import { AppContentStatus } from '../../../config/AppContentStatus';
import { useTranslation } from 'react-i18next';

const ContentStatusNotification = (props) => {
  const { t } = useTranslation();

  return (
    props.status === AppContentStatus.None ?
      null
      :
      <div id="content-status-notification">
        {props.status === AppContentStatus.NewContentAvailable &&
          <div className="loader"></div>
        }
        {props.status === AppContentStatus.NewContentInstalled &&
          <div className="success">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"></path>
            </svg>
          </div>
        }
        {props.status === AppContentStatus.Error &&
          <div className="error">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM10 15a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-4a1 1 0 0 1-2 0V6a1 1 0 0 1 2 0v5Z"></path>
            </svg>
          </div>
        }
        <div className="message">
          { t(`contentStatus.${props.status}`) } 
        </div>
        {props.status !== AppContentStatus.NewContentAvailable &&
          <button type="button" className="close" onClick={props.reset}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"></path>
              </svg>
          </button>
        }
      </div>
  );
}

export default ContentStatusNotification;